import { Button, mq } from '@kvdbil/components';
import React, { MouseEvent, useCallback, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0.25rem 1rem;
  color: ${({ theme }) => theme.colors.text.dark};
  background: ${({ theme }) => theme.colors.success.lighter}};

  ${mq('tablet')} {
    padding: 0.5rem 2rem;
  }
`;

const Content = styled.div`
  max-width: 1024px;
  margin: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export interface ActionMessageProps {
  onError(): void;
  message: string;
  buttonMessage: string;
  buttonClickedMessage?: string;
  onClickAction(): Promise<unknown>;
}
export const ActionMessage = ({
  onError,
  message,
  buttonMessage,
  buttonClickedMessage,
  onClickAction
}: ActionMessageProps) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleResend = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      setIsSending(true);

      return onClickAction()
        .then(() => setIsClicked(prev => !prev))
        .catch(onError)
        .finally(() => setIsSending(false));
    },
    [onClickAction, onError]
  );

  return (
    <Container data-test="message-confirm-email" aria-live="polite">
      <Content>
        <span>{message}</span>

        <div>
          {buttonClickedMessage && isClicked ? (
            <span>{buttonClickedMessage}</span>
          ) : (
            <Button
              onClick={handleResend}
              data-testid="auction-message-button"
              variant="flat"
              color="neutral"
              isLoading={isSending}
            >
              {buttonMessage}
            </Button>
          )}
        </div>
      </Content>
    </Container>
  );
};

export default ActionMessage;
